export const matchupKeys = {
	matchupSettings: (matchupId: string) => [`MATCHUP_SETTINGS`, matchupId] as const
} as const;
